import { em } from 'polished'
import styled, { css } from 'styled-components'

import { BaseWrapper, BaseBoxWrapper } from '../styles'

export const Wrapper = styled(BaseWrapper)`
  padding-top: ${em(115)};
  position: relative;
  height: ${em(629)};

  ${p => p.theme.mq.upLg} {
    margin-bottom: ${em(150)};
  }
`

export const BoxWrapper = styled(BaseBoxWrapper)`
  position: absolute;
  ${({ productType }) => boxWrapperStyles[productType]}

  ${p => p.theme.mq.upLg} {
    position: static;
  }
`

export const BoxInner = styled.div`
  width: ${em(424)};
`

const boxWrapperStyles = {
  dna: css`
    padding-right: ${em(25)};
    justify-self: end;
  `,
  wgs: css`
    padding-left: ${em(13)};
  `,
}

export const DesktopIndicator = styled.div`
  position: absolute;
  bottom: 0;
`

export const TitleBox = styled.div`
  ${p => p.theme.mq.upMd} {
    margin-bottom: ${em(40)};
  }
`
